//@import dependencies
import React, {Fragment, useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import parse from 'html-react-parser'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
//@end

//@import components
import IconComponent from 'app_components/commons/icons'
import AlertComponent from 'app_components/commons/alert'
import RelatedCoursesSkeleton from './relatedCoursesSkeleton'
import OfferCardComponent from 'app_components/commons/offercard'
//@end

// @import hooks
import useWindowWidth from 'app_hooks/useWindowWidth'
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
// @end

// @INFO Import services
import {routingService} from 'app_services/routingService'
// @end

// @INFO Import Styles
import './../relatedCoursesModule.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import { RelatedCoursesModuleBreakItem } from '../containers/relatedCoursesModule';
import FilterCourseCard from 'app_components/screens/landing/AcademicFilterScreen/components/FilterCourseCard/FilterCourseCard';
import moment from 'moment';
import { ICourse } from 'app_types/campus/academic/courseTypes';
import { CourseSchedulingCourseType } from 'app_types/admin/courseScheduling/courseSchedulingTypes';

// @ADD Component types
interface IRelatedCoursesModuleLayoutProps {
  status: 'loading' | 'error' | null
  courses: Array<ICourse>
  content: string
  initialNumberCarousel?: number;
  breakpointItems?: RelatedCoursesModuleBreakItem[]
  title?: any
  hideFooterText?: boolean;
  className?: string;
  hideExtraInformation?: boolean
  hidePrice?: boolean
}

const defaultBreakpoints: RelatedCoursesModuleBreakItem[] = [
  { width: 991, items: 2 },
  { width: 576, items: 1 },
  { width: 'default', items: 4 },
]

const RelatedCoursesModuleLayout: React.FC<IRelatedCoursesModuleLayoutProps> = (props) => {

  const [breakpoints, setBreakpoints] = useState<RelatedCoursesModuleBreakItem[]>(defaultBreakpoints)
  const { windowWidth } = useWindowWidth()
  const [colors] = useColors()
  const { t } = useTranslation()

  useEffect(() => {
    if (props.breakpointItems?.length) {
      setBreakpoints(props.breakpointItems)
    } else {
      setBreakpoints(defaultBreakpoints)
    }
  }, [props.breakpointItems])

  const getNumberItems = () => {
    const defaultBreakpoints = breakpoints.filter((br) => br.width === 'default')
    const defaultItems: number = props.initialNumberCarousel ? props.initialNumberCarousel : defaultBreakpoints?.length
      ?
        defaultBreakpoints[0].items
      :
        4
    const _windowWidth = windowWidth
    const _breakpoints = breakpoints.filter((br) => br.width !== 'default' && _windowWidth < br.width)
    _breakpoints.sort((a,b) => (a.width as number) - (b.width as number))
    if (_breakpoints?.length) {
      return _breakpoints[0].items
    } else {
      return defaultItems
    }
  }

  const CustomArrow = (props: any) => {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        {props.icon}
      </div>
    );
  }

  console.log(props.courses)

  return(
    <div className={`related_courses-component ${props.className || ''}`}>
      {props.title && (
        <TextComponent
          type='subtitle'
          style={{
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '1.1rem',
          }}
          styleDiv={{
            justifyContent: 'center'
          }}
        >
          {props.title}
        </TextComponent>
      )}

      <div className="course-list-container">
        {props.status === 'loading' ? (
          <RelatedCoursesSkeleton />
        ) : (
          <>
            {props.courses && Array.isArray(props.courses) && props.courses.length > 0 ? (
              <>
              {props.content === 'list' ? (
                <div className="course-list">
                  <p>Hello</p>
                  {props.courses.map((course) => (
                    <div key={course.key}>
                      <FilterCourseCard
                        modality={course.schedulingMode?.name}
                        name={course.program?.name}
                        startDate={moment(course.startDate?.replace('T00:00:00.000Z', '')).format('DD/MM/YYYY')}
                        duration={course.duration}
                        key={course._id}
                        slug={course?.extra_info?.slug as string}
                        courseId={course._id}
                        image={course.extra_info?.coverUrl}
                        schedule={course.schedule}
                        serviceInformation={course?.serviceInformation}
                        sharePosition='dropup'
                        withoutTutor={course?.withoutTutor}
                        formationType={course?.extra_info?.formationType}
                        quickLearning={course?.quickLearning}
                      />
                    </div>
                  ))}
                </div>
              ): null}
              {props.content === 'slider' ? (
                <>
                  <Slider
                    arrows={true}
                    infinite={(props.courses?.length >= getNumberItems()) ? true : false}
                    slidesToShow={getNumberItems()}
                    nextArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleRight' width={24} color={colors.primary} />}/>}
                    prevArrow={<CustomArrow icon={<IconComponent svg='ArrowCircleLeft' width={24} color={colors.primary} />}/>}
                  >
                    {props.courses.map((course) => (
                      <Fragment key={`fragment_${course.key}`}>
                        <div className='item' key={course.key}>
                          <FilterCourseCard
                            modality={course.schedulingMode?.name}
                            name={course.program?.name}
                            startDate={moment(course.startDate?.replace('T00:00:00.000Z', '')).format('DD/MM/YYYY')}
                            duration={course.duration}
                            key={course._id}
                            slug={course?.extra_info?.slug as string}
                            courseId={course._id}
                            image={course.extra_info?.coverUrl}
                            schedule={course.schedule}
                            serviceInformation={course?.serviceInformation}
                            sharePosition='dropup'
                            withoutTutor={course?.withoutTutor}
                            formationType={course?.extra_info?.formationType}
                            quickLearning={course?.quickLearning}
                            isMooc={course?.typeCourse === CourseSchedulingCourseType.MOOC}
                          />
                        </div>
                      </Fragment>
                    ))}
                  </Slider>
                </>
              ): null}
              </>
            ) : (
              <>
                <AlertComponent
                  type='warning'
                  title={t('modules.related_courses.no_data')}
                />
              </>
            )}

            {!props.hideFooterText ?
              <div className="course-footer">
                <div className="content">
                  {parse(t('modules.related_courses.footer.content'))}
                  <br />
                </div>
              </div>
            :null}
          </>
        )}
      </div>

    </div>
  )
}

export default RelatedCoursesModuleLayout
